import cls from 'classnames'
import type { ReactNode } from 'react'
import { Glyph } from '../Glyph'

type WarningBadgeProps = {
	readonly children?: ReactNode
	readonly className?: string
}

export const WarningBadge = ({ children, className = '' }: WarningBadgeProps) => (
	<figure className={cls('flex-center w-5.5 h-5.5 bg-yellow rounded-full', className)}>
		{children || <Glyph name="warning" size="xs" className="text-white !-mt-px" />}
	</figure>
)
